module.exports = __webpack_public_path__ + "static/media/1.b39558ca.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row5/1.wav
// module id = 85
// module chunks = 0